import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "60px 24px", lineHeight: "1.7", fontFamily: "sans-serif", color: "#1a1a1a" }}>
      <h1 style={{ fontSize: "28px", marginBottom: "8px" }}>Privacy Policy</h1>
      <p style={{ color: "#666", marginBottom: "32px" }}>Last updated: 27 July 2026</p>

      <p>
        DXB Property Zones ("we", "our", "us") operates dxbpropertyzones.com. This Privacy Policy
        explains how we collect, use, and protect your personal information when you visit our
        Site or submit an inquiry through our lead forms, landing pages, or advertising campaigns.
      </p>

      <h2 style={{ fontSize: "20px", marginTop: "32px" }}>1. Information We Collect</h2>
      <p>When you submit a form or inquiry on our Site, we may collect:</p>
      <ul>
        <li>Full name</li>
        <li>Phone number</li>
        <li>Email address</li>
        <li>Property preferences and budget range</li>
        <li>Any other information you voluntarily provide</li>
      </ul>
      <p>
        We may also automatically collect certain technical information, including your IP
        address, browser type, device information, pages visited, and referral source.
      </p>

      <h2 style={{ fontSize: "20px", marginTop: "32px" }}>2. How We Use Your Information</h2>
      <p>We use your information to:</p>
      <ul>
        <li>Respond to your property inquiries</li>
        <li>Send you relevant property listings and updates, where you have provided your consent</li>
        <li>Improve our website and marketing campaigns</li>
        <li>Measure and analyze the performance of our services</li>
        <li>Comply with applicable legal obligations</li>
      </ul>

      <h2 style={{ fontSize: "20px", marginTop: "32px" }}>3. Sharing Your Information</h2>
      <p>
        We do not sell your personal information. We may share your information with property
        developers, brokers, or trusted partners directly relevant to your inquiry, as well as
        service providers who assist us in operating our website and delivering our services.
      </p>

      <h2 style={{ fontSize: "20px", marginTop: "32px" }}>4. Data Retention</h2>
      <p>
        We retain your personal information only for as long as necessary to fulfill the purposes
        described in this Privacy Policy or as required by applicable law.
      </p>

      <h2 style={{ fontSize: "20px", marginTop: "32px" }}>5. Your Rights</h2>
      <p>
        Subject to applicable laws, you may request access to, correction of, or deletion of your
        personal information.
      </p>

      <h2 style={{ fontSize: "20px", marginTop: "32px" }}>6. Cookies</h2>
      <p>
        Our Site may use cookies and similar technologies to improve your browsing experience,
        analyze website performance, and enhance our services. You can manage or disable cookies
        through your browser settings at any time.
      </p>

      <h2 style={{ fontSize: "20px", marginTop: "32px" }}>7. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy or how your data is handled, you can
        reach us at:
      </p>
      <p>
        Email: dxbpropertyzone1@gmail.com<br />
        Phone: +971 58 612 4320
      </p>
    </div>
  );
};

export default PrivacyPolicy;